import { useState, useEffect, useRef, useCallback } from 'react'
import { withRouter } from "react-router"
import { Formik, Form } from 'formik'
import ButtonSubmitCancel from '../general/ButtonSubmitCancel'
import FormMovieDataTabContainer from '../../containers/forms/FormMovieDataTabContainer'
// import * as Yup from 'yup';
import {
    INFORMATION,
    IMAGES,
    ATTRIBUTES,
    PLAYTIMES
} from '../../constants/tabTypes'
import { sanitizeFormInput, sanitizeFormOutput } from '../../functions/formFunctions'
import Translation from '../Translation/cont/Translation'
import movieAttrToSourceAttr from '../../functions/movieAttrToSourceAttr'
import { truncateText } from '../../functions/truncateText'
import { ORIGIN_TMDB, ORIGIN_DATA_PROVIDER, ORIGIN_PM } from '../../constants/metaMovieOrigins'

const DESCRIPTION_SHORT_MAX_LENGTH = 220

const FormMovieData = ({
    movieData,
    metaData,
    sourceData,
    sourceDataProvider,
    onUpdateExtension,
    onResetExtension,
    sourceMoviesByItemId,
    performances,
    attributes,
    closePagePath,
    history,
    onUpdateItem,
    movieExtensionsItems,
    movieExtensionsToReset,
    cliMovieRelevantSourceMovies,
    onChangeField,
    onResetField,
    isTmdbLinked,
    hasPreviewMovie,
    onSetOrigin,
    pmMovie,
    tmdbMovie,
}) => {
    // const validationSchema = () => {
    //     Yup.object().shape({
    //     movie: Yup.object({
    //         displayDates: Yup.object({
    //             start: Yup.date(),
    //             end: Yup.date()
    //                 .min(yup.ref('start'), 'Liegt vor dem Startdatum')
    //           }),
    //       }),
    //     // title: Yup.string()
    //     //     .required('Dieses Feld wird benötigt!'),
    //     // movieId: Yup.string()
    //     //     .required('Es muss ein Film ausgewählt werden!'),
    // });}

    const [movieImages, setMovieImages] = useState([])
    const [imagesTouched, setImagesTouched] = useState(false)
    const genreOriginSyncedRef = useRef(false)

    // Stable identity so it doesn't bust ImagesMovieDisplayAndUploadList's memo
    // boundary (and the grid callbacks' useCallback deps) on every Formik
    // render-prop run — see the movies-with-many-backgrounds regression this fixes.
    const handleImagesTouched = useCallback(() => setImagesTouched(true), [])

    const setMovieImageValues = (images, values) => {
        const imagesCopy = []
        let ambient = ''
        let backgrounds = []

        images.map((img, index) => {
            imagesCopy.push({...img})
            delete imagesCopy[index].itemId
        })

        if(images.length > 0) {
            ambient = imagesCopy.shift()
        } 

        if(images.length > 1) {
            backgrounds = imagesCopy
        }

        values.movie.images.ambient = ambient
        values.movie.images.backgrounds = backgrounds
    }

    return (
        <Formik
            initialValues={
                sanitizeFormInput({
                    movie: movieData,
                    attributes: attributes,
                    performances: performances,
                    movieExtensionsItems: movieExtensionsItems,
                    cliMovieRelevantSourceMovies: cliMovieRelevantSourceMovies,
                    movieExtensionsEdited: [],
                    movieExtensionsReset: movieExtensionsToReset,
                    sourceMoviesByItemId: sourceMoviesByItemId
                })
            }
            onSubmit={(values, actions) => {
                // an empty list is a valid result ("all images deleted"), so the
                // flag has to say whether the user touched the grid at all
                if(imagesTouched) {
                    setMovieImageValues(movieImages, values)
                }

                if(0 !== values.movieExtensionsEdited.length) {
                    values.movieExtensionsEdited.map(movieExtensionsItemKey => {
                        const currentMovieExtensionsItem = values.movieExtensionsItems[movieExtensionsItemKey]
                        if(currentMovieExtensionsItem.technologyAttributes !== '') {
                            onUpdateExtension(movieExtensionsItemKey, 'technologyAttributes', currentMovieExtensionsItem.technologyAttributes)
                        } 
                        if(currentMovieExtensionsItem.alternateLink !== '') {
                            onUpdateExtension(movieExtensionsItemKey, 'alternateLink', currentMovieExtensionsItem.alternateLink)
                        } else {
                            onResetExtension(movieExtensionsItemKey, 'alternateLink')
                        }
                    })
                }

                if(0 !== values.movieExtensionsReset.length) {
                    values.movieExtensionsReset.map(movieExtensionsItemKey => {
                        if(!movieExtensionsToReset.includes(movieExtensionsItemKey)) {
                            onResetExtension(movieExtensionsItemKey, 'technologyAttributes')
                        }
                    })
                }

                onUpdateItem(sanitizeFormOutput(values), metaData)
                actions.setSubmitting(false)
                history.push(closePagePath)
            }}
            // validationSchema={validationSchema}
            onReset={(values, actions) => {
                history.push(closePagePath)
            }}>
            {({ values, errors, status, touched, isSubmitting, handleReset, setFieldValue, handleChange }) => {
                const onChange = key => e => {
                    if(e) handleChange(e)
                    onChangeField(key)
                }
                
                const onReset = (key) => {
                    const sourceKey = movieAttrToSourceAttr(key, sourceDataProvider)
                    const sourceValue = sourceData[sourceKey] ? _.isArray(sourceData[sourceKey]) ? sourceData[sourceKey][0] : sourceData[sourceKey] : ""
                    setFieldValue('movie.' + key, sourceValue)
                    onResetField(key)
                }

                const applyGenres = (genreNames) => {
                    const movieId = values.movie.id
                    const genreAttrs = values.attributes && values.attributes.global && values.attributes.global.genres
                    if (!genreAttrs || !movieId) return
                    Object.keys(genreAttrs).forEach(attrId => {
                        const attr = genreAttrs[attrId]
                        const inNew = genreNames.includes(attr.name)
                        const inCurrent = attr.movies.includes(movieId)
                        if (inNew && !inCurrent) {
                            setFieldValue(`attributes.global.genres.${attrId}.movies`, [...attr.movies, movieId])
                        } else if (!inNew && inCurrent) {
                            setFieldValue(`attributes.global.genres.${attrId}.movies`, attr.movies.filter(m => m !== movieId))
                        }
                    })
                    setFieldValue('movie.genres', genreNames)
                }

                const mapTmdbActors = (actors) => (actors || []).map(a => ({
                    name: a.name || '',
                    character: a.character || null,
                    id: null,
                    imageURL: a.profile_url || null,
                }))

                const handleSetOrigin = (key, origin) => {
                    onSetOrigin(key, origin)
                    if (key === 'logo') {
                        if (origin === ORIGIN_PM && pmMovie && pmMovie.logo && pmMovie.logo.url) {
                            const l = pmMovie.logo
                            setFieldValue('movie.logo', { ...l, id: l.id || '' })
                        } else if (origin === ORIGIN_TMDB && tmdbMovie && tmdbMovie.logo_url) {
                            setFieldValue('movie.logo', { id: '', format: null, alt: '', url: tmdbMovie.logo_url, position: null })
                        }
                    } else if (key === 'genres') {
                        if (origin === ORIGIN_PM && pmMovie) applyGenres(pmMovie.genres || [])
                        else if (origin === ORIGIN_TMDB && tmdbMovie) applyGenres(tmdbMovie.genres || [])
                        else if (origin === ORIGIN_DATA_PROVIDER) {
                            if (sourceDataProvider === 'DieselV2' && tmdbMovie) {
                                applyGenres(tmdbMovie.genres || [])
                            } else {
                                const sourceKey = movieAttrToSourceAttr(key, sourceDataProvider)
                                applyGenres(sourceKey && _.isArray(sourceData[sourceKey]) ? sourceData[sourceKey] : [])
                            }
                        }
                    } else if (key === 'actors') {
                        if (origin === ORIGIN_TMDB && tmdbMovie) {
                            setFieldValue('movie.actors', mapTmdbActors(tmdbMovie.actors))
                        } else if (origin === ORIGIN_DATA_PROVIDER) {
                            if ((sourceDataProvider === 'DieselV2' || sourceDataProvider === 'Vista') && tmdbMovie) {
                                setFieldValue('movie.actors', mapTmdbActors(tmdbMovie.actors))
                            } else {
                                const sourceKey = movieAttrToSourceAttr(key, sourceDataProvider)
                                setFieldValue('movie.actors', sourceKey ? (sourceData[sourceKey] || []) : [])
                            }
                        }
                    } else if (key === 'original_title') {
                        if (origin === ORIGIN_TMDB && tmdbMovie) {
                            setFieldValue('movie.origTitle', tmdbMovie.original_title || '')
                        } else if (origin === ORIGIN_DATA_PROVIDER) {
                            const sourceKey = movieAttrToSourceAttr(key, sourceDataProvider)
                            setFieldValue('movie.origTitle', sourceKey ? (sourceData[sourceKey] || '') : '')
                        } else if (origin === ORIGIN_PM && pmMovie) {
                            setFieldValue('movie.origTitle', pmMovie.originalTitle || '')
                        }
                    } else if (key === 'starting_date') {
                        if (origin === ORIGIN_TMDB && tmdbMovie) {
                            setFieldValue('movie.startingDate', tmdbMovie.release_date || null)
                        } else if (origin === ORIGIN_DATA_PROVIDER) {
                            const sourceKey = movieAttrToSourceAttr(key, sourceDataProvider)
                            setFieldValue('movie.startingDate', sourceKey ? (sourceData[sourceKey] || null) : null)
                        } else if (origin === ORIGIN_PM && pmMovie) {
                            setFieldValue('movie.startingDate', pmMovie.startingDate || null)
                        }
                    } else if (key === 'visible_from') {
                        // ORIGIN_DATA_PROVIDER intentionally does not touch the field value here —
                        // visible_from has no client-fetchable provider value (it's derived
                        // server-side from performances), so switching to it just disables the
                        // field and leaves whatever was displayed until a save+reload brings in
                        // the real backend-computed value.
                        if (origin === ORIGIN_PM && pmMovie) {
                            setFieldValue('movie.limitations.visibleFrom', pmMovie.visibleFrom || null)
                        }
                    } else if (origin === ORIGIN_PM && pmMovie) {
                        if (key === 'trailerURL') setFieldValue('movie.trailerURL', pmMovie.trailerURL || '')
                        else if (key === 'description') {
                            setFieldValue('movie.description', pmMovie.description || '')
                            setFieldValue('movie.descriptionShort', truncateText(pmMovie.description || '', DESCRIPTION_SHORT_MAX_LENGTH))
                        }
                    } else if (origin === ORIGIN_TMDB && tmdbMovie) {
                        if (key === 'title') setFieldValue('movie.title', tmdbMovie.title || '')
                        else if (key === 'description') {
                            setFieldValue('movie.description', tmdbMovie.description || '')
                            setFieldValue('movie.descriptionShort', truncateText(tmdbMovie.description || '', DESCRIPTION_SHORT_MAX_LENGTH))
                        }
                    } else if (origin === ORIGIN_DATA_PROVIDER) {
                        if (key === 'title') {
                            setFieldValue('movie.title', sourceData.title || values.movie.title || '')
                        } else if (key === 'description' && sourceDataProvider === 'DieselV2' && tmdbMovie) {
                            setFieldValue('movie.description', tmdbMovie.description || '')
                            setFieldValue('movie.descriptionShort', truncateText(tmdbMovie.description || '', DESCRIPTION_SHORT_MAX_LENGTH))
                        } else {
                            const sourceKey = movieAttrToSourceAttr(key, sourceDataProvider)
                            if (sourceKey && key !== 'logo') {
                                const raw = sourceData[sourceKey]
                                setFieldValue('movie.' + key, raw ? (_.isArray(raw) ? raw[0] : raw) : '')
                            }
                        }
                    }
                }

                useEffect(() => {
                    if (genreOriginSyncedRef.current) return
                    const origin = metaData && metaData.genres
                    if (!origin) return
                    const dataReady = (origin === ORIGIN_TMDB && tmdbMovie)
                        || (origin === ORIGIN_PM && pmMovie)
                        || origin === ORIGIN_DATA_PROVIDER
                    if (!dataReady) return
                    genreOriginSyncedRef.current = true
                    handleSetOrigin('genres', origin)
                }, [metaData, tmdbMovie, pmMovie])

                return (
                <Form
                className='moviedata-form'>
                    <FormMovieDataTabContainer
                        defaultTab={INFORMATION}
                        values={values}
                        setFieldValue={setFieldValue}
                        metaData={metaData}
                        setMovieImages={setMovieImages}
                        onImagesTouched={handleImagesTouched}
                        onChange={onChange}
                        handleChange={handleChange}
                        onReset={onReset}
                        isTmdbLinked={isTmdbLinked}
                        hasPreviewMovie={hasPreviewMovie}
                        hasProviderMovie={!!(sourceMoviesByItemId && sourceMoviesByItemId.length > 0)}
                        isCompesoProvider={sourceDataProvider === 'Compeso'}
                        onSetOrigin={handleSetOrigin}
                        tabs={[
                            {
                                "title": <Translation id="movie_edit_tab_information"/>,
                                "id": INFORMATION
                            },
                            {
                                "title": <Translation id="movie_edit_tab_movie_series" />,
                                "id": ATTRIBUTES
                            },
                            {
                                "title": <Translation id="movie_edit_tab_movie_times" />,
                                "id": PLAYTIMES
                            },
                            {
                                "title": <Translation id="movie_edit_tab_movie_images" />,
                                "id": IMAGES
                            }
                        ]}
                    >
                    </FormMovieDataTabContainer>

                    <ButtonSubmitCancel
                        transIdCancel="cancel_button"
                        transIdSubmit="save_movie_button"
                        disabledCancel={isSubmitting}
                        disabledSubmit={isSubmitting}
                        onCancel={handleReset}
                    />

                </Form>
            )}}
        </Formik>
    )
}

export default withRouter(FormMovieData)